export const screenPhoto = `
 mutation ScreenPhoto ($filename: String!, $file: String!, $mediaCategory: String!) {
  screenPhoto(filename: $filename, file: $file, mediaCategory: $mediaCategory) {
    scanId,
    hasPassedMediaScreen
  }
}
`
